var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVineMobileLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18m.069 13.54c.783 0 4.568-3.686 4.568-5.135 0-1.871-.488-2.863-2.28-2.986-1.573.123-2.288 1.753-2.288 1.753S10.44 7.524 8.989 7.4C7.11 7.524 6.5 8.534 6.5 10.405c0 1.452 3.753 5.135 4.569 5.135"
})));
export default SvgVineMobileLike;